import { ReactNode } from 'react';

import { BoardThemes } from '@exports/ChessBoard';
import { BoardThemePreview } from '@ui/components/BoardThemePreview/BoardThemePreview';
import { PopoverMenuItem, PopoverSubMenu } from '@ui/components/PopoverMenu/PopoverMenu';

type Props = {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  boardTheme: BoardThemes;
  setBoardTheme: (theme: BoardThemes) => void;
};
const OPTIONS: { value: BoardThemes; label: ReactNode }[] = [
  { value: 'classic', label: 'Классический' },
  { value: 'classic-lite', label: 'Классический светлый' },
  { value: 'gray-wood', label: 'Серое дерево' },
  { value: 'green', label: 'Зеленый' },
  { value: 'blue', label: 'Синий' },
];

export function BoardThemeSubMenu({
  className,
  isOpen,
  onClose,
  boardTheme,
  setBoardTheme,
}: Props) {
  return (
    <PopoverSubMenu className={className} title="Цвет доски" isOpen={isOpen} onClose={onClose}>
      {OPTIONS.map((o) => (
        <PopoverMenuItem
          key={o.value}
          isSelected={o.value === boardTheme}
          onClick={() => setBoardTheme(o.value)}
        >
          {o.label}

          <BoardThemePreview boardTheme={o.value} />
        </PopoverMenuItem>
      ))}
    </PopoverSubMenu>
  );
}
